module.exports = __webpack_public_path__ + "img/icon-insta-thin.8cbcc279.svg";